import clsx from 'clsx';

import type { UIComponentBase } from '../../@types/types';

const Divider = ({ className }: Omit<UIComponentBase, 'children'>) => (
  <div className={clsx('border-b border-gray-200', className)} />
);

export default Divider;
